/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_organization_steps_welcome_description = /** @type {(inputs: {}) => string} */ () => {
	return `Con Bloque puedes iniciar tu nuevo negocio o usar el que ya tienes para recibir pagos y controlar gastos con tarjetas.`
};

const en_organization_steps_welcome_description = /** @type {(inputs: {}) => string} */ () => {
	return `With Bloque you can start your new business or use the one you already have to receive payments and control spending with cards.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const organization_steps_welcome_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.organization_steps_welcome_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("organization_steps_welcome_description", locale)
	if (locale === "es") return es_organization_steps_welcome_description(inputs)
	return en_organization_steps_welcome_description(inputs)
};
export { organization_steps_welcome_description as "organization.steps.welcome_description" }